export class VariableSetting {
    /**
     * 变量Id
     */
    // variableId: string;
    /**
     * 变量编号
     */
    variableCode: string;
    /**
     * 变量名称
     */
    variableName: string;
    /**
     * 自定义标签，赋值方式
     * expression 语义化表达式
     * constant 常量
     * component 构件
     */
    tag: string;

    /**
     * 变量执行时机
     * ACTIVITY_STARTED 活动开始
     * ACTIVITY_COMPLETED 活动完成
     */
    executionTime: string;

    /**
     * 变量值
     */
    value: string;

    valueText: string;

    /**
     * 构件
     */
    component: any;
}
